import { Injectable } from '@angular/core';
import { EntityState, EntityStore } from '@examdojo/state';
import { CurrentReviewHttpModel, ReviewItemStoreModel } from './review-item.model';

export interface ReviewItemState extends EntityState<ReviewItemStoreModel> {
  props: {
    session?: CurrentReviewHttpModel['review_session'];
  };
}

@Injectable({ providedIn: 'root' })
export class ReviewItemStore extends EntityStore<ReviewItemState, ReviewItemStoreModel, 'id'> {
  constructor() {
    super({
      name: 'review-items',
      idKey: 'id',
    });
  }
}
